import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminUsersApi } from '../api/admin-users.api';
import { adminUserKeys } from './queryKeys';
import { Notification } from '@/shared/components/ahkinia/Notification/notification';

interface ActivateAdminUserParams {
  adminUserId: string;
  reason: string;
}

export const useActivateAdminUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ adminUserId, reason }: ActivateAdminUserParams) =>
      adminUsersApi.activateUser(adminUserId, { reason }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminUserKeys.all });
      Notification.success({
        title: 'Usuario activado',
        description: 'El usuario ha sido activado exitosamente.',
      });
    },
  });
};
